import PictureBox from './picturebox.vue';
export default PictureBox;


// WEBPACK FOOTER //
// ./src/components/picturebox/index.js